import './navigation';
import './header';
import './ajax-add-to-cart';
import './anim_hero';
import './button';

import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollSmoother from "gsap/ScrollSmoother";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

ScrollTrigger.matchMedia({


  "(min-width: 768px)": function() {

    const anim = gsap.to("#smooth-content", {
      y: -150,
      ease: "none",
      scrollTrigger: {
        trigger: "#smooth-wrapper",
        start: "top bottom",
        end: "bottom top",
        scrub: 2,
      },
    });

  },

  // < 768px
  "(max-width: 767px)": function() {
    // Tutaj możesz wyczyścić / wyłączyć / zresetować jeśli potrzeba
    // np. gsap.set("#smooth-content", { clearProps: "all" });
  }

});